


















































































interface tableData {
    accountBookId: number
    depreciateSubject: string
    depreciateSubjectText: string
    feeSubject: string
    feeSubjectText: string
    id: number
    isInit: number
    leaf: number
    method: string
    name: string
    no: string
    oldValueRate: number
    useMonth: number
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { mapGetters } from "vuex";
import AssetClassVue from "./AssetClass.vue";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "asset-class": AssetClassVue,
    }
})
export default class CategoryManagement extends Vue {
    tableData: tableData[] = [];
    @Prop({ type: Number })
    assetType!: number;

    mounted() {
        this.fetchData()
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .get(`fixedAssetsCategory/${this.$store.state.accountBook.id}/findall?assetType=${this.assetType}`)
            .then(res => {
                this.tableData = res.data
            });
    }

    // 新增
    isAdd: boolean = false
    showAsset: boolean = false
    isAsset() {
        this.assetData = null;
        this.isAdd = true
        this.showAsset = true;
    }
    closeAsset() {
        this.showAsset = false
        this.assetData = null
    }
    assetSuccess() {
        this.fetchData()
        this.showAsset = false
        this.assetData = null
    }
    // 编辑
    assetData: tableData | null = null
    changeClass(data: tableData) {
        this.assetData = null;
        this.isAdd = false
        this.assetData = data
        this.showAsset = true;
    }
    // 删除
    delAssetClass(id: number) {
        this.$confirm("亲，此操作将删除该类别, 是否继续?", "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
            Vue.axios
                .post(`fixedAssetsCategory/delete`, {
                    id: id,
                    accountBookId: this.$store.state.accountBook.id,
                    assetType: this.assetType
                })
                .then(res => {
                    this.fetchData()
                });
        }).catch(() => {
            this.$message({
                type: "info",
                message: "已取消删除"
            });
        });
    }

}
